import React from 'react';
import {
    Box,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    useTheme
} from '@mui/material';
import {observer} from "mobx-react";
import FormAutocompleteField from "./fields/FormAutocompleteField";
import Typography from "@mui/material/Typography";
import FormNumberField from "./fields/FormNumberField";
import DeleteIcon from "@mui/icons-material/Delete";
import MoneyRenderer from "../utils/MoneyRenderer";

function ArticleTable({label, form, feature}) {
    const theme = useTheme();
    const canEditArticles = feature.canEditArticles()
    return (
        <Box sx={{maxHeight: 500, overflowX: 'auto', overflowY: 'auto', width: "100%"}}>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{minWidth: 180}}>Código</TableCell>
                            <TableCell sx={{minWidth: 250}}>Nombre</TableCell>
                            <TableCell sx={{flex: 1}}>Familia</TableCell>
                            <TableCell sx={{flex: 1}}>Precio</TableCell>
                            <TableCell sx={{width: 80}}>Cantidad</TableCell>
                            <TableCell sx={{width: 50}}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            Object.entries(form.formsPerId).map(([id, articleForm]) => {
                                const pricedArticle = getArticleFor(articleForm)
                                return (
                                    <TableRow key={id}>
                                        <TableCell>
                                            <FormAutocompleteField
                                                field={articleForm.codeField()}
                                                options={feature.articleCodesOptions()}
                                                selectedValue={(event, value) => {
                                                    updateValueOf('code', feature.articleCodesOptions(),
                                                        value, articleForm,
                                                        (name) => feature.articleWithCode(name),
                                                        (article) => articleForm.updateArticle(article)
                                                    )
                                                }
                                                }
                                                fullWidth
                                                readOnly={!canEditArticles}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <FormAutocompleteField
                                                field={articleForm.nameField()}
                                                options={feature.articleNamesOptions()}
                                                selectedValue={(event, value) => {
                                                    updateValueOf('name', feature.articleNamesOptions(),
                                                        value, articleForm,
                                                        (name) => feature.articleWithName(name),
                                                        (article) => articleForm.updateArticle(article)
                                                    )
                                                }
                                                }
                                                fullWidth
                                                readOnly={!canEditArticles}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Typography>{pricedArticle && pricedArticle.article.category}</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography>{pricedArticle && (feature.isFreeOrder? MoneyRenderer(0) : MoneyRenderer(pricedArticle.price.amount))}</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <FormNumberField
                                                field={articleForm.amountField()}
                                                updateValue={(event, value) => {
                                                    form.updateValue('amount', value, id)
                                                }}
                                                disabled={!canEditArticles}
                                                width={'100%'}
                                            />
                                        </TableCell>
                                        {canEditArticles && <TableCell>
                                            <IconButton onClick={() => form.deleteForm(id)} disabled={!canEditArticles}>
                                                <DeleteIcon color="error"/>
                                            </IconButton>
                                        </TableCell>}
                                    </TableRow>
                                )
                            })
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );

    function updateValueOf(fieldName, fieldOptions, selectedValue, form, getObjectForValue, updateObject) {
        if (selectedValue) {
            const object = getObjectForValue(selectedValue)
            updateObject(object)
        } else {
            form.clear()
        }
    }

    function getArticleFor(form) {
        const articleForId = form.article()
        let priced_article;
        if (articleForId.code !== '') {
            priced_article = feature.pricedArticleWithCode(articleForId.code)
        } else if (articleForId.name !== '') {
            priced_article = feature.pricedArticleWithName(articleForId.name)
        }
        return priced_article
    }
}

export default observer(ArticleTable);